import { AnsweringClient } from "../../../../clients/answeringClient";

export interface IAssignment {
  applicationId: number;
  title: string;
  dueDate: Date;
  instrumentTitle: string;
}

export interface DeleteAssignmentModalControllerDelegate {
  didDeleteAssignment: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
}

export class DeleteAssignmentModalController {
  constructor(
    private delegate: DeleteAssignmentModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async deleteAssignment(
    accessToken: string,
    userUid: string,
    assignmentId: number
  ) {
    try {
      await this.answeringClient.deleteAssignment(
        accessToken,
        userUid,
        assignmentId
      );
      this.delegate.didDeleteAssignment();
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.deleteAssignment(newTokens.accessToken, userUid, assignmentId);
        return;
      }
      this.delegate.genericError();
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
